/*
 * @Author: Oliver
 * @Date: 2025-03-27 13:59:14
 * @LastEditors: Oliver
 * @LastEditTime: 2025-03-31 13:57:19
 * @FilePath: /kepler/src/utils/editorDB.js
 */
import Dexie from 'dexie'
// const Dexie = require('dexie').default;
// 创建名为 editor_database 的数据库
const db = new Dexie('editor_database')
// 这里可以定义版本号，后续修改表字段时可以增加版本号
db.version(1).stores({
  // 创建 docUpdate 表，&表示 primaryKey（++表示自增字段）
  files: `++id,filename,files,status`,
})

// 修改为同时支持默认导出和命名导出
export const editorDB = db;
export default db;
